import React from 'react'
import { graphql } from 'gatsby'
import { BlogNav, AuthorHeader, BlogCtaBanner, PostGrid, Section, SEO } from 'newComponents'
import Layout from '../components/layout.js'
import './author.scss'

const Author = ({ data: staticData, location, pageContext }) => {
  // const data = setupPreviewData(staticData);

  const paginationAmount = 12

  // page data
  const { author, authorsPosts } = staticData
  const { data: pageData } = author
  const { nodes: postList = [] } = authorsPosts

  const {
    metaTitle,
    metaDesc,
    ogImage,
    author_bio: bio,
    author_image: image,
    author_name: name,
    twitter_handle_url: twitter
  } = pageData

  const suggestedPosts = postList.slice(0, 6)

  // seo data
  const seo = {
    title: metaTitle?.text || `Posts by ${name?.text}`,
    description: metaDesc?.text || bio?.text || `Read articles written by ${name?.text}`,
    ogImage: ogImage?.url
  }

  return (
    <Layout staticNavbar>
      <SEO {...seo} />
      <div className="author">
        <BlogNav />
        <AuthorHeader name={name} bio={bio} image={image} twitter={twitter} />
        <Section className="author-posts-container">
          <PostGrid
            posts={postList}
            title={`Stories by ${name.text}`}
            className="grid-variant"
            paginationAmount={paginationAmount}
          />
        </Section>
        <PostGrid posts={suggestedPosts} title="You May Like" className="suggested-variant" />
        {/* <BlogCtaBanner /> */}
      </div>
    </Layout>
  )
}

export default Author

export const authorQuery = graphql`
  query AuthorBySlug($uid: String!) {
    author: prismicAuthor(uid: { eq: $uid }) {
      id
      uid
      prismicId
      data {
        metaTitle: meta_title {
          text
        }
        metaDesc: meta_description {
          text
        }
        ogImage: open_graph_image {
          url
        }
        author_bio {
          html
          text
        }
        author_image {
          url
          localFile {
            childImageSharp {
              fluid(maxWidth: 400, quality: 90) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
        author_name {
          text
          html
        }
        twitter_handle_url {
          url
        }
      }
    }
    authorsPosts: allPrismicBlogPost(
      filter: { data: { author: { uid: { eq: $uid } } } }
      sort: { order: DESC, fields: data___timestamp }
    ) {
      nodes {
        uid
        id
        data {
          categories {
            category {
              uid
              id
            }
          }
          title {
            html
            text
          }
          featured_image {
            url
            localFile {
              childImageSharp {
                fluid(maxWidth: 800, quality: 90) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          excerpt {
            html
            text
          }
          hide_date
          timestamp(formatString: "MMMM D, YYYY")
          author {
            uid
            id
            document {
              ... on PrismicAuthor {
                id
                uid
                data {
                  author_name {
                    text
                    html
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
